/**
 * <LeaveNoticeToast>: transient notice when an audience member leaves
 * mid-game.
 *
 * Per PRD §3.8 the server emits PLAYER_LEAVE_NOTICE for audience
 * disconnects during active game phases (drawer disconnects use
 * DRAWER_DISCONNECT_GRACE instead). The client store carries the latest
 * notice on `game.lastLeaveNotice`; this component renders a paper banner
 * that auto-fades after a few seconds. Re-keys on `at` so a fresh notice
 * remounts cleanly.
 */

import { PaperBanner } from "./PaperBanner.js";

type LeaveNoticeToastProps = {
  displayName: string;
  reason: "disconnect" | "leave";
  /** Timestamp from the store entry; used as React key for remount-on-new. */
  at: number;
};

const DURATION_MS = 4000;

export function LeaveNoticeToast({ displayName, reason, at }: LeaveNoticeToastProps) {
  const verb = reason === "disconnect" ? "disconnected" : "left";
  return (
    <div data-testid="leave-notice-toast" data-leaver={displayName}>
      <PaperBanner key={at} kind="info" message={`${displayName} ${verb}`} duration={DURATION_MS} />
    </div>
  );
}
